import styled from 'styled-components';

const Typography = styled.div`
	font-size: 14px;
	color: ${props => props.theme.colors.textPrimary};

	${props =>
		props.align &&
		`
      text-align: ${props.align};
    `};

	${props =>
		props.xs &&
		`
    font-size: ${props.theme.font.xs};
  `};

	${props =>
		props.sm &&
		`
    font-size: ${props.theme.font.sm};
  `};

	${props =>
		props.md &&
		`
    font-size: ${props.theme.font.md};
  `};

	${props =>
		props.lg &&
		`
    font-size: ${props.theme.font.lg};
  `};

	${props =>
		props.fontSize &&
		`
    font-size: ${props.fontSize}px;
  `};

	${props =>
		props.bold &&
		`
    font-weight: ${props.theme.font.bold};
  `};

	${props =>
		props.regular &&
		`
    font-weight: ${props.theme.font.regular};
  `};

	${props =>
		props.light &&
		`
    font-weight: ${props.theme.font.light};
  `};

	${props =>
		props.primary &&
		`
    color: ${props.theme.colors.primary};
  `};

	${props =>
		props.success &&
		`
    color: ${props.theme.colors.success};
  `};

	${props =>
		props.info &&
		`
    color: ${props.theme.colors.info};
  `};

	${props =>
		props.danger &&
		`
    color: ${props.theme.colors.danger};
  `};

	${props =>
		props.textPrimary &&
		`
    color: ${props.theme.colors.textPrimary};
  `};

	${props =>
		props.white &&
		`
    color: ${props.theme.colors.lightGrey};
  `};

	${props =>
		props.marginT &&
		`
    margin-top: ${props.marginT}px;
  `};

	${props =>
		props.marginR &&
		`
    margin-right: ${props.marginR}px;
  `};

	${props =>
		props.marginB &&
		`
    margin-bottom: ${props.marginB}px;
  `};

	${props =>
		props.marginL &&
		`
    margin-left: ${props.marginL}px;
  `};

	${props =>
		props.clickable &&
		`
    text-decoration: underline;
    cursor: pointer;
  `};
`;

export default Typography;
